const base_url = process.env.NEXT_PUBLIC_BASE_URL

export const CREATE_GROUP_CART_API = `${base_url}/api/group-cart`